// import { useEffect, useMemo, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Layout, Menu, Input, Button, Typography } from 'antd';
// import {
//     MenuFoldOutlined,
//     MenuUnfoldOutlined,
//     SearchOutlined,
//     LogoutOutlined
// } from '@ant-design/icons';
// import { MenuList } from './nav/MenuList';
// import LogoService from '../Services/Manage/LogoService';
// import { ENDPOINT } from '../Services/ENDPOINT';
// import { message } from 'antd';


// const { Text } = Typography;

// export default function SideBar({ collapsed, setCollapsed, isMobile, setIsMobile }) {
//     const [searchValue, setSearchValue] = useState('');
//     const navigate = useNavigate();

//     const [logoUrl, setLogoUrl] = useState('');

//     const toggleCollapsed = () => setCollapsed(!collapsed);

//     useEffect(() => {
//     async function fetchLogo() {
//         try {
//             const response = await LogoService.getAllLogos();
//             if (response.success && response.data.length > 0) {
//                 const logo = response.data[0];

//                 const normalizeUrl = (url) => {
//                     const baseUrl = ENDPOINT.base.replace(/\/+$/, '');
//                     const path = url.replace(/^\/+/, '');
//                     const fullUrl = url.startsWith('http') ? url : `${baseUrl}/${path}`;
//                     return fullUrl.replace(/([^:]\/)\/+/g, "$1");
//                 };

//                 setLogoUrl(normalizeUrl(logo.image_path));
//             }
//         } catch (error) {
//             message.error("Failed to load logo");
//         }
//     }
//     fetchLogo();
// }, []);


//     const ome_permission = localStorage.getItem("ome_permission");
//     const request_1 = JSON.parse(ome_permission);
//     console.log(`{request_1}`);
    

//     const permissions = JSON.parse(
//         `${request_1}`
//         // `[{"module":"Enquiry","link":"/enquiry","add":true,"edit":true,"delete":false,"read":true},{"module":"Quotation","link":"/quotation","add":true,"edit":true,"delete":false,"read":true},{"module":"Invoice","link":"/invoice","add":true,"edit":true,"delete":false,"read":true},{"module":"Project","link":"/projects","add":true,"edit":true,"delete":false,"read":true},{"module":"Permission","link":"/manage-permission","add":true,"edit":true,"delete":false,"read":true},{"module":"Expenses","link":"/manage-expense","add":true,"edit":true,"delete":false,"read":true},{"module":"Vendors","link":"/manage-vendor","add":true,"edit":true,"delete":false,"read":true},{"module":"Employees","link":"/manage-employees","add":true,"edit":true,"delete":false,"read":true},{"module":"Bank Details","link":"/manage-bank-data","add":true,"edit":true,"delete":false,"read":true},{"module":"Letter Header & others","link":"/manage-letter-formats","add":false,"edit":false,"delete":false,"read":false}]`
//     );

//     // 🔹 Filter menu items based on permission rules
//     const filterByPermission = (items) => {
//         return items
//             .map(item => {
//                 if (item.children) {
//                     const filteredChildren = filterByPermission(item.children);
//                     return filteredChildren.length > 0 ? { ...item, children: filteredChildren } : null;
//                 }

//                 const permission = permissions.find(p => p.link === item.to);
//                 const hasAccess =
//                     permission && (permission.add || permission.edit || permission.delete || permission.read);

//                 return hasAccess ? item : null;
//             })
//             .filter(Boolean);
//     };

//     // 🔹 Search filter logic
//     const filterMenuItems = (items, searchText) => {
//         if (!searchText) return items;
//         return items
//             .filter(item => {
//                 const matches = item.label.toLowerCase().includes(searchText.toLowerCase());
//                 if (item.children) {
//                     const filteredChildren = filterMenuItems(item.children, searchText);
//                     return matches || filteredChildren.length > 0;
//                 }
//                 return matches;
//             })
//             .map(item => {
//                 if (item.children) {
//                     return { ...item, children: filterMenuItems(item.children, searchText) };
//                 }
//                 return item;
//             });
//     };

//     // 🔹 Format menu with navigation handlers
//     const formatMenuItems = (items, isRoot = true) => {
//         const formattedItems = items.map(item => ({
//             key: item.key,
//             icon: item.icon,
//             label: item.label,
//             children: item.children ? formatMenuItems(item.children, false) : undefined,
//             onClick: !item.children ? () => navigate(item.to) : undefined,
//         }));

//         if (isRoot) {
//             formattedItems.push({
//                 key: 'logout',
//                 icon: <LogoutOutlined />,
//                 label: 'Logout',
//                 onClick: () => {
//                     localStorage.removeItem('ome_token');
//                     localStorage.removeItem('ome_user');
//                     localStorage.removeItem('ome_permission');
                    
//                     window.location.reload();
//                 },
//             });
//         }

//         return formattedItems;
//     };

//     // 🔹 Combine permission and search filters
//     const filteredMenuItems = useMemo(() => {
//         const permissionFiltered = filterByPermission(MenuList);
//         const searchFiltered = filterMenuItems(permissionFiltered, searchValue);
//         return formatMenuItems(searchFiltered);
//     }, [MenuList, searchValue]);

//     const handleSearchChange = (e) => setSearchValue(e.target.value);

//     return (
//         <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//             {/* Header */}
//        <div
//     style={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         padding: 12,
//         borderBottom: '1px solid rgba(243, 15, 15, 0.1)',
//         flexShrink: 0,
//     }}
// >
//     {/* Logo or Text */}
//     <div
//         style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: collapsed ? 'center' : 'flex-start',
//             gap: '8px',
//             width: '100%'
//         }}
//     >
//         {collapsed ? (
//             logoUrl && (
//                 <img
//                     src={logoUrl}
//                     alt="Logo"
//                     onClick={toggleCollapsed}
//                     style={{
//                         width: 40,
//                         height: 40,
//                         objectFit: 'contain',
//                         borderRadius: 4,
//                         cursor: 'pointer'
//                     }}
//                 />
//             )
//         ) : (
//             <Text
//                 strong
//                 style={{ color: 'rgba(14, 93, 146, 0.95)', fontSize: '25px' }}
//             >
//                 Shreesh{' '}
//                 <Text
//                     strong
//                     style={{ color: 'rgba(0, 0, 0, 0.95)', fontSize: '25px' }}
//                 >
//                     Tech
//                 </Text>
//             </Text>
//         )}
//     </div>

//     {/* Collapse button */}
//     {!collapsed && (
//         <Button
//             type="text"
//             icon={<MenuFoldOutlined style={{ color: '#000', fontSize: '25px' }} />}
//             onClick={toggleCollapsed}
//             style={{ width: 40, height: 40 }}
//         />
//     )}
// </div>


//             {/* Search */}
//             {!collapsed && (
//                 <div style={{
//                     padding: 12,
//                     borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
//                     flexShrink: 0
//                 }}>
//                     <Input
//                         placeholder="Search..."
//                         prefix={<SearchOutlined style={{ color: 'rgba(23, 113, 148, 0.71)' }} />}
//                         style={{
//                             backgroundColor: 'rgba(255, 255, 255, 1)',
//                             border: '1px solid rgba(255, 255, 255, 0.71)',
//                             color: 'rgba(0, 0, 0, 0.71)',
//                             borderRadius: '8px',
//                         }}
//                         value={searchValue}
//                         onChange={handleSearchChange}
//                         allowClear
//                     />
//                 </div>
//             )}

//             {/* Scrollable menu */}
//             <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
//                 <Menu
//                     theme="light"
//                     mode="inline"
//                     style={{ borderRight: 0, color: '#e0e0e0', background: '#d0e0e8ff' }}
//                     items={filteredMenuItems}
//                     className="white-text-with-stroke"
//                 />
//             </div>
//         </div>
//     );
// }



// display all the sidebar menu for development purpose only

import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Menu, Input, Button, Typography, message, Modal } from 'antd';

import { MenuFoldOutlined, MenuUnfoldOutlined, SearchOutlined, LogoutOutlined } from '@ant-design/icons';
import { MenuList } from './nav/MenuList';
import LogoService from '../Services/Manage/LogoService';
import { ENDPOINT } from '../Services/ENDPOINT';



const { Text } = Typography;

export default function SideBar({ collapsed, setCollapsed, isMobile, setIsMobile }) {
    const [searchValue, setSearchValue] = useState('');
    const [logoUrl, setLogoUrl] = useState('');
    const navigate = useNavigate();

    const normalizeUrl = (url) => {
        const baseUrl = ENDPOINT.base.replace(/\/+$/, '');
        const path = url.replace(/^\/+/, '');
        const fullUrl = url.startsWith('http') ? url : `${baseUrl}/${path}`;
        return fullUrl.replace(/([^:]\/)\/+/g, "$1");
    };

    useEffect(() => {
        async function fetchLogo() {
            try {
                const response = await LogoService.getAllLogos();
                if (response.success && response.data.length > 0) {
                    const logo = response.data[0];
                    setLogoUrl(normalizeUrl(logo.image_path));
                }
            } catch (error) {
                message.error("Failed to load logo");
            }
        }
        fetchLogo();
    }, []);

    const toggleCollapsed = () => setCollapsed(!collapsed);

    const filterMenuItems = (items, searchText) => {
        if (!searchText) return items;

        return items.filter(item => {
            const matches = item.label.toLowerCase().includes(searchText.toLowerCase());
            if (item.children) {
                const filteredChildren = filterMenuItems(item.children, searchText);
                return matches || filteredChildren.length > 0;
            }
            return matches;
        }).map(item => {
            if (item.children) {
                return {
                    ...item,
                    children: filterMenuItems(item.children, searchText)
                };
            }
            return item;
        });
    };

    const formatMenuItems = (items, isRoot = true) => {
        const formattedItems = items.map(item => ({
            key: item.key,
            icon: item.icon,
            label: item.label,
            children: item.children ? formatMenuItems(item.children, false) : undefined,
            onClick: !item.children ? () => navigate(item.to) : undefined,
        }));

        if (isRoot) {
            formattedItems.push({
        key: 'logout',
                icon: <LogoutOutlined />,
                label: 'Logout',
                onClick: () => {
  Modal.confirm({
                        title: 'Logout',
                        content: 'Are you sure you want to logout?',
                        okText: 'Yes, Logout',
                        cancelText: 'Cancel',
                        okType: 'danger',
                        centered: true,
                        width: 450,
                        onOk: () => {
                            localStorage.removeItem('ome_token');
                            localStorage.removeItem('ome_user');
                            localStorage.removeItem('ome_permission');
                            window.location.reload();
                        },
                    });
                },
            });
        }

        return formattedItems;
    };

    // const filteredMenuItems = useMemo(() => {
    //     const filtered = filterMenuItems(MenuList, searchValue);
    //     return formatMenuItems(filtered);
    // }, [MenuList, searchValue]);

const permissions = useMemo(() => {
    try {
        const raw = localStorage.getItem("ome_permission");
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    } catch { return []; }
}, []);

const filterByPermission = (items) => {
    return items.map(item => {
        if (item.children) {
            const filteredChildren = filterByPermission(item.children);
            return filteredChildren.length > 0 ? { ...item, children: filteredChildren } : null;
        }
        const permission = permissions.find(p => p.link === item.to);
        const hasAccess = permission && (permission.add || permission.edit || permission.delete || permission.read);
        return hasAccess ? item : null;
    }).filter(Boolean);
};

const filteredMenuItems = useMemo(() => {
    const permissionFiltered = filterByPermission(MenuList);
    const searchFiltered = filterMenuItems(permissionFiltered, searchValue);
    return formatMenuItems(searchFiltered);
}, [MenuList, searchValue, permissions]);

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        }}>

            {/* Fixed header */}
            <div style={{
                padding: 12,
                borderBottom: '1px solid rgba(243, 15, 15, 0.1)',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                {/* Left side: either logo image or text */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: collapsed ? 'center' : 'flex-start',
                        gap: '8px',
                        width: '100%' // Ensures it takes full width for centering
                    }}
                >
                    {collapsed ? (
                        logoUrl && (
                            <img
                                src={logoUrl}
                                alt="Logo"
                                onClick={toggleCollapsed}
                                style={{
                                    width: 40,
                                    height: 40,
                                    objectFit: 'contain',
                                    borderRadius: 4,
                                    cursor: 'pointer'
                                }}
                            />
                        )
                    ) : (
                <Text
  strong
  style={{ color: 'rgba(14, 93, 146, 0.95)', fontSize: '25px' }} 
>
  Shreesh
  <Text
    strong
    style={{ color: 'rgba(0, 0, 0, 0.95)', fontSize: '25px' }}
  >
    Tech
  </Text>
</Text>

                    )}
                </div>


                {/* Toggle button (works for both collapsed and expanded) */}
                {!collapsed && (
                    <Button
                        type="text"
                        icon={
                            <MenuFoldOutlined style={{ color: '#000', fontSize: '25px' }} />
                        }
                        onClick={toggleCollapsed}
                        style={{ width: 40, height: 40 }}
                    />
                )}


            </div>


            {/* Search (only when expanded) */}
            {!collapsed && (
                <div style={{
                    padding: 12,
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    flexShrink: 0
                }}>
                    <Input
                        placeholder="Search..."
                        prefix={<SearchOutlined style={{ color: 'rgba(23, 113, 148, 0.71)' }} />}
                        style={{
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                            border: '1px solid rgba(255, 255, 255, 0.71)',
                            color: 'rgba(0, 0, 0, 0.71)',
                            borderRadius: '8px',
                        }}
                        value={searchValue}
                        onChange={handleSearchChange}
                        allowClear
                    />
                </div>
            )}

            {/* Scrollable menu */}
            <div
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}
            >
                <Menu
                    theme="light"
                    mode="inline"
                    style={{ borderRight: 0, color: '#e0e0e0', background: '#d0e0e8ff' }}
                    items={filteredMenuItems}
                    className="white-text-with-stroke"
                />
            </div>
        </div>
    );
}
